import React from "react"
import { Link } from "react-router-dom"
import ActivityCellRenderer from "../subcomponents/Assessments/AssessmentsGrid/ActivityCellRenderer/ActivityCellRenderer"
import { getDateColDef } from "components/grids/columnTemplates"
import { intersperse } from "utilities/misc"

// apis
import { useGetStudyActivities } from "api/hooks/studies/useActivitiesApi"

export default function useActivitiesColDefs(studyId, ongoingOnly) {
  const { data: activities = [] } = useGetStudyActivities(studyId)
  const columnDefs = React.useMemo(() => {
    const columns = [
      {
        headerName: "Activity",
        field: "project_title",
        cellRenderer: ActivityCellRenderer,
      },
      {
        headerName: "Category",
        field: "project_category",
      },
      {
        headerName: "Registry",
        field: "registry_name",
        cellRenderer: "RegistryCellRenderer",
        cellClass: ["col-badge"],
      },
      {
        headerName: "Step",
        field: "curr_state",
        suppressSizeToFit: true,
        cellRenderer: "WorkflowStatusBadge",
        cellRendererParams: {
          list: activities,
        },
        cellClass: ["col-badge"],
      },
      {
        headerName: "Due Date",
        field: "project_due_date",
        ...getDateColDef({ gridIsControlled: true }),
      },
      {
        headerName: "Projected Completion Date",
        field: "projected_completion_date",
        ...getDateColDef({ gridIsControlled: true }),
      },
    ]
    // Actual completion date added to Activities grid, but not to Overview tab grid, which only shows ongoing activities
    if (!ongoingOnly) {
      columns.push({
        headerName: "Actual Completion Date",
        field: "actual_completion_date",
        ...getDateColDef({ gridIsControlled: true }),
      })
    }
    columns.push(
      {
        headerName: "Assessment",
        field: "attached_assessments",
        filterParams: {
          keyCreator: ({ value }) => value?.assessment_name,
          valueFormatter: ({ value }) => value?.assessment_name,
        },
        cellRenderer: (params) => {
          return (
            <div className="attached-assessments-pill-container">
              {intersperse(
                params.value.map((assess) => {
                  return (
                    <Link
                      className="prime-link"
                      to={`/study/${studyId}/assessment/${assess.assessment_pk}`}
                    >
                      {assess.assessment_name}
                    </Link>
                  )
                }),
                ", "
              )}
            </div>
          )
        },
      },
      {
        headerName: "Risk",
        field: "status",
        cellRenderer: "StatusCellRenderer",
      },
      {
        headerName: "As Of Date",
        field: "last_action_time",
        ...getDateColDef({ gridIsControlled: true }),
      }
    )
    return columns
  }, [activities])

  return { columnDefs }
}
